// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__15TwK","notes":"Notes_notes__37WMO","note":"Notes_note__3HwhZ","markdown":"Notes_markdown__3kmaB"};